module.exports = {"app":{"title":"Todo List"},"tabs":{"all":"All","undone":"Undone","done":"Done"},"input":{"placeholder":"New Todo","add":"Add"},"todolist":{"notodo":"No todo found."}}


//////////////////
// WEBPACK FOOTER
// ./src/locales/en.json
// module id = 5
// module chunks = 2